// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__PDEfl","error":"Input_error__wNiLM"};